<template>
  <div class="container">
    <HeaderView />
    <div :class="{
      'bg-content': $store.state.screenWidth > 375,
      'bg-content-se': $store.state.screenWidth <= 375,
      'bg-content-4': $store.state.screenWidth <= 320,
    }">
      <div class="form-page">
        <div class="form-card">
          <div class="form-heading">
            <span class="heading-icon"><img src="/static/img/logo/open-house-2026.png" alt="RMUTL Open House 2026" /></span>
            <div>
              <p>ข้อมูลผู้เข้าร่วมงาน</p>
              <h2>โปรไฟล์ของฉัน</h2>
            </div>
          </div>
          <section class="profile-qr" aria-labelledby="profile-qr-title">
            <div class="profile-qr__content">
              <p class="profile-qr__eyebrow">QR CODE ประจำตัวผู้เข้าร่วมงาน</p>
              <h3 id="profile-qr-title">{{ fullname || 'ผู้เข้าร่วมงาน' }}</h3>
              <p>แสดง QR Code นี้ เพื่อยืนยันตัวตน </p>
              <button type="button" class="profile-qr__download" :disabled="!qrCodeDataUrl"
                @click="downloadQrCode">
                <i class="ti ti-download"></i>
                <span>ดาวน์โหลด QR Code</span>
              </button>
            </div>
            <div class="profile-qr__image-wrap">
              <img v-if="qrCodeDataUrl" class="profile-qr__image" :src="qrCodeDataUrl"
                :alt="'QR Code ผู้เข้าร่วมงาน ' + (fullname || citizen_id)" />
              <div v-else class="profile-qr__placeholder" aria-live="polite">
                <i class="ti ti-qrcode"></i>
                <span>กำลังสร้าง QR Code</span>
              </div>
            </div>
          </section>
          <form id="formprofile" class="needs-validation form-grid" novalidate autocomplete="off">
            <div class="form-field">
              <label>เลขบัตรประชาชนหรือเลขพาสปอร์ต/Citizen&Passportid</label>
              <input class="form-control" type="text" v-model="citizen_id" autocomplete="off" required readonly />
            </div>
            <div class="form-field">
              <label>เพศ/Gender</label>
              <select class="form-select" :class="validationClass('gender')" v-model="gender" required>
                <option :value="0">กรุณาเลือกเพศ</option>
                <option :value="1">ชาย</option>
                <option :value="2">หญิง</option>
              </select>
            </div>
            <div class="form-field">
              <label>ชื่อ - นามสกุล/Fullname</label>
              <input class="form-control" :class="validationClass('fullname')" type="text" v-model="fullname"
                autocomplete="off" required />
            </div>
            <div class="form-field">
              <label>เบอร์โทรศัพท์/Telephone</label>
              <input class="form-control" :class="validationClass('tel')" type="text" v-model="tel"
                v-mask="'###-###-####'" autocomplete="off" required />
            </div>
            <div class="form-field">
              <label>อีเมล/Email</label>
              <input class="form-control" :class="validationClass('email')" type="email" v-model="email"
                autocomplete="off" required />
            </div>
            <div class="form-field">
              <label>ภูมิลำเนา/Origin Province</label>
              <Select2 class="regis-select2 d-block" :class="validationClass('origin_province_id')"
                :key="'origin-province-' + origin_province_id + '-' + provinceOptions.length"
                :data="provinceOptions" :value="origin_province_id" :min-count-for-search="0"
                @update="origin_province_id = $event" />
              <input type="hidden" name="origin_province" :value="origin_province_id" />
            </div>
            <div class="form-field">
              <label>สถานศึกษาปัจจุบัน/School</label>
              <vue-bootstrap-typeahead :inputClass="schoolInputClass" ref="school" v-model="school"
                :data="school_lists" />
            </div>
            <div class="form-field">
              <label>สถานะผู้เข้าร่วม/Participant Status</label>
              <select class="form-select" :class="validationClass('participant_status')" name="status"
                v-model="participant_status">
                <option :value="0">กรุณาเลือกสถานะผู้เข้าร่วม</option>
                <option value="นักเรียน">นักเรียน</option>
                <option value="นักศึกษา">นักศึกษา</option>
                <option value="อาจารย์แนะแนว">อาจารย์แนะแนว</option>
                <option value="บุคคลทั่วไป">บุคคลทั่วไป</option>
              </select>
            </div>
            <div class="form-field">
              <label>เขตพื้นที่ที่สนใจ/Campus</label>
              <select class="form-select" :class="validationClass('campus_id')" name="campus" v-model="campus_id"
                required>
                <option :value="0">กรุณาเลือกเขตพื้นที่</option>
                <option v-for="(cp, i) in campus_list" :key="'rcp' + i" :value="cp.campus_id_pri">
                  {{ cp.campus_name }}
                </option>
              </select>
            </div>
            <div class="form-field">
              <label>คณะที่สนใจ/faculty</label>
              <select class="form-select" :class="validationClass('facId')" v-model="facId" required>
                <option :value="0">กรุณาเลือกคณะ</option>
                <option v-for="(fac, i) in fac_list" :key="'rcf' + i" :value="fac.faculty_id">
                  {{ fac.faculty_name }}
                </option>
              </select>
            </div>
            <div class="form-field field-wide">
              <label>สาขาวิชาที่สนใจ/major</label>
              <Select2 class="regis-select2 d-block" :class="validationClass('major')" :data="majorOptions"
                :key="'major-' + major + '-' + majorOptions.length"
                :value="major" :min-count-for-search="0" @update="major = $event" />
              <input type="hidden" name="major" :value="major" />
            </div>
          </form>
          <div class="form-actions">
            <button class="btn btn-primary-action" @click="validateForm">
              <i class="ti ti-device-floppy"></i>
              <span>บันทึก</span>
            </button>
            <button class="btn btn-danger-action" @click="logout">
              <i class="ti ti-logout"></i>
              <span>ออกจากระบบ</span>
            </button>
            <button class="btn btn-secondary-action" @click="$router.push('/activity')">
              <i class="ti ti-chevron-left"></i>
              <span>ย้อนกลับ</span>
            </button>
          </div>
        </div>
      </div>
      <div style="height: 100px;" />
    </div>
  </div>
</template>

<script>
import HeaderView from './layouts/HeaderView.vue'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import { Select2 } from 'select2-vue-component'
import 'select2-component/dist/select2.min.css'
import Swal from 'sweetalert2'
import api from '../assets/services'
import $ from 'jquery'
import QRCode from 'qrcode'

export default {
  components: {
    HeaderView,
    VueBootstrapTypeahead,
    Select2,
  },
  data() {
    return {
      school_lists: [],
      citizen_id: '',
      fullname: '',
      tel: '',
      email: '',
      school: '',
      gender: 0,
      origin_province_id: 0,
      campus_list: [],
      campus_id: 0,
      fac_list: [],
      facId: 0,
      dep_list: [],
      dep_id: 0,
      major_list: [],
      major: 0,
      province_list: [],
      depName: '',
      isSubmitted: false,
      participant_status: 'นักเรียน',
      user_qr_code: '',
      qrCodeDataUrl: '',
    }
  },
  computed: {
    schoolInputClass() {
      return ['form-control', this.validationClass('school')].filter(Boolean).join(' ')
    },
    provinceOptions() {
      return [
        { value: 0, label: 'กรุณาเลือกภูมิลำเนา' },
        ...this.province_list.map((prv) => ({
          value: Number(prv.province_id),
          label: prv.province_name,
        })),
      ]
    },
    departmentOptions() {
      const facultyId = Number(this.facId)
      const departmentList = facultyId > 0
        ? this.dep_list.filter((dep) => Number(dep.faculty_id) === facultyId)
        : this.dep_list

      return [
        { value: 0, label: 'กรุณาเลือกหลักสูตร' },
        ...departmentList.map((dep) => ({
          value: Number(dep.department_id_pri),
          label: dep.department_name,
        })),
      ]
    },
    majorOptions() {
      return [
        { value: 0, label: 'กรุณาเลือกสาขาวิชา' },
        ...this.major_list.map((mj) => ({
          value: Number(mj.major_id_pri),
          label: mj.major_name,
        })),
      ]
    },
  },
  watch: {
    user_qr_code: {
      immediate: true,
      handler() {
        this.generateQrCode()
      },
    },
    '$store.state.user': {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!newValue) {
          return
        }

        this.citizen_id = newValue.citizenId
        this.user_qr_code = newValue.user_qr_code || ''
        this.fullname = newValue.fullname
        this.tel = newValue.tel
        this.email = newValue.email
        this.school = newValue.school
        this.gender = Number(newValue.gender || 0)
        this.setOriginProvince(newValue)
        this.campus_id = Number(newValue.campus_id_pri || 0)
        this.facId = Number(newValue.faculty_id || newValue.facId || 0)
        this.setAcademicProgram(newValue)
        this.depName = newValue.department_name || newValue.depName || ''
        this.participant_status = newValue.participant_status || 'นักเรียน'
        this.$nextTick(() => {
          if (this.$refs.school) {
            this.$refs.school.inputValue = this.school
          }
        })
      },
    },
    facId() {
      this.resetDepartmentIfUnavailable()
    },
    major_list() {
      this.setAcademicProgram(this.$store.state.user)
      this.resetMajorIfUnavailable()
    },
    dep_list() {
      this.setAcademicProgram(this.$store.state.user)
      this.resetDepartmentIfUnavailable()
    },
    province_list() {
      this.setOriginProvince(this.$store.state.user)
    },
  },
  methods: {
    async downloadQrCode() {
      if (!this.qrCodeDataUrl) {
        return
      }

      try {
        if (document.fonts && document.fonts.ready) {
          await document.fonts.ready
        }

        const qrImage = await new Promise((resolve, reject) => {
          const image = new Image()
          image.onload = () => resolve(image)
          image.onerror = reject
          image.src = this.qrCodeDataUrl
        })
        const canvas = document.createElement('canvas')
        canvas.width = 1080
        canvas.height = 1280
        const context = canvas.getContext('2d')
        const background = context.createLinearGradient(0, 0, canvas.width, canvas.height)
        background.addColorStop(0, '#fffaf0')
        background.addColorStop(1, '#ffffff')
        context.fillStyle = background
        context.fillRect(0, 0, canvas.width, canvas.height)
        context.strokeStyle = '#d8b779'
        context.lineWidth = 8
        context.strokeRect(34, 34, canvas.width - 68, canvas.height - 68)

        context.textAlign = 'center'
        context.fillStyle = '#9a6c28'
        context.font = '500 34px Mitr, sans-serif'
        context.fillText('RMUTL OPEN HOUSE 2026', canvas.width / 2, 120)

        const displayName = this.fullname || 'ผู้เข้าร่วมงาน'
        context.fillStyle = '#2f241b'
        context.font = '600 58px Mitr, sans-serif'
        context.fillText(displayName, canvas.width / 2, 210, 940)
        context.fillStyle = '#735f4d'
        context.font = '400 28px Mitr, sans-serif'
        context.fillText('QR Code ประจำตัวผู้เข้าร่วมงาน', canvas.width / 2, 265)

        context.fillStyle = '#ffffff'
        context.shadowColor = 'rgba(76, 50, 31, 0.15)'
        context.shadowBlur = 28
        context.fillRect(150, 320, 780, 780)
        context.shadowColor = 'transparent'
        context.drawImage(qrImage, 185, 355, 710, 710)

        context.fillStyle = '#8a714f'
        context.font = '400 27px Mitr, sans-serif'
        context.fillText('แสดง QR Code นี้เพื่อยืนยันตัวตน', canvas.width / 2, 1170)

        const safeName = displayName.replace(/[\\/:*?"<>|]/g, '-').trim() || 'participant'
        const link = document.createElement('a')
        link.download = 'RMUTL-Open-House-QR-' + safeName + '.png'
        link.href = canvas.toDataURL('image/png')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (_error) {
        Swal.fire({
          title: 'ดาวน์โหลดไม่สำเร็จ',
          text: 'ไม่สามารถสร้างไฟล์ QR Code ได้ กรุณาลองใหม่อีกครั้ง',
          icon: 'warning',
          confirmButtonText: 'ตกลง',
        })
      }
    },
    async generateQrCode() {
      if (!this.user_qr_code) {
        this.qrCodeDataUrl = ''
        return
      }

      try {
        this.qrCodeDataUrl = await QRCode.toDataURL(String(this.user_qr_code), {
          errorCorrectionLevel: 'M',
          margin: 2,
          width: 360,
          color: {
            dark: '#2f241b',
            light: '#ffffff',
          },
        })
      } catch (_error) {
        this.qrCodeDataUrl = ''
      }
    },
    setOriginProvince(profile) {
      if (!profile) {
        this.origin_province_id = 0
        return
      }

      const originProvince = Number(profile.origin_province || profile.origin_province_id || 0)
      if (originProvince > 0) {
        this.origin_province_id = originProvince
        return
      }

      const province = this.province_list.find((prv) => prv.province_name === profile.province_name)
      this.origin_province_id = province ? Number(province.province_id) : 0
    },
    setAcademicProgram(profile) {
      if (!profile) {
        this.dep_id = 0
        this.major = 0
        return
      }

      const departmentId = Number(profile.department_id_pri || profile.department_id || 0)
      if (departmentId > 0) {
        this.dep_id = departmentId
      } else {
        const department = this.dep_list.find((dep) => dep.department_name === profile.department_name)
        this.dep_id = department ? Number(department.department_id_pri) : 0
      }

      const majorId = Number(profile.major_id_pri || profile.major_id || 0)
      if (majorId > 0) {
        this.major = majorId
        return
      }

      const major = this.major_list.find((mj) => mj.major_name === profile.major_name)
      this.major = major ? Number(major.major_id_pri) : 0
    },
    resetDepartmentIfUnavailable() {
      const depId = Number(this.dep_id)
      if (depId === 0 || this.dep_list.length === 0) {
        return
      }

      const isAvailable = this.departmentOptions.some((dep) => Number(dep.value) === depId)
      if (!isAvailable) {
        this.dep_id = 0
      }
    },
    resetMajorIfUnavailable() {
      const majorId = Number(this.major)
      if (majorId === 0 || this.major_list.length === 0) {
        return
      }

      const isAvailable = this.majorOptions.some((mj) => Number(mj.value) === majorId)
      if (!isAvailable) {
        this.major = 0
      }
    },
    isBlank(value) {
      return value === null || value === undefined || String(value).trim() === ''
    },
    isZero(value) {
      return Number(value) === 0
    },
    isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim())
    },
    isValidTel(value) {
      return String(value).replace(/\D/g, '').length === 10
    },
    isFieldValid(field) {
      const validations = {
        gender: !this.isZero(this.gender),
        fullname: !this.isBlank(this.fullname),
        tel: !this.isBlank(this.tel) && this.isValidTel(this.tel),
        email: !this.isBlank(this.email) && this.isValidEmail(this.email),
        origin_province_id: !this.isZero(this.origin_province_id),
        school: !this.isBlank(this.school),
        campus_id: !this.isZero(this.campus_id),
        facId: !this.isZero(this.facId),
        major: !this.isZero(this.major),
        participant_status: !this.isZero(this.participant_status),
      }

      return validations[field] === true
    },
    validationClass(field) {
      if (!this.isSubmitted) {
        return ''
      }

      return this.isFieldValid(field) ? 'is-valid' : 'is-invalid'
    },
    showValidationAlert(text) {
      return Swal.fire({
        title: 'ตรวจสอบ',
        text,
        icon: 'warning',
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: 'ตกลง',
        denyButtonText: 'ยกเลิก',
      })
    },
    validateProfileData() {
      const validations = [
        {
          invalid: this.isZero(this.gender),
          message: 'กรุณาเลือกเพศ',
        },
        {
          invalid: this.isBlank(this.fullname),
          message: 'กรุณากรอกชื่อ - นามสกุล',
        },
        {
          invalid: this.isBlank(this.tel) || !this.isValidTel(this.tel),
          message: 'กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก',
        },
        {
          invalid: this.isBlank(this.email) || !this.isValidEmail(this.email),
          message: 'กรุณากรอกอีเมลให้ถูกต้อง',
        },
        {
          invalid: this.isZero(this.origin_province_id),
          message: 'กรุณาเลือกภูมิลำเนา',
        },
        {
          invalid: this.isBlank(this.school),
          message: 'กรุณากรอกชื่อโรงเรียนปัจจุบัน',
        },
        {
          invalid: this.isZero(this.campus_id),
          message: 'กรุณาเลือกเขตพื้นที่ที่สนใจ',
        },
        {
          invalid: this.isZero(this.facId),
          message: 'กรุณาเลือกคณะที่สนใจ',
        },
        {
          invalid: this.isZero(this.major),
          message: 'กรุณาเลือกสาขาวิชาที่สนใจ',
        },
        {
          invalid: this.isZero(this.participant_status),
          message: 'กรุณาเลือกสถานะผู้เข้าร่วม',
        },
      ]

      return validations.find((validation) => validation.invalid)
    },
    validateForm() {
      this.isSubmitted = true

      const invalidProfileData = this.validateProfileData()
      if (invalidProfileData) {
        this.showValidationAlert(invalidProfileData.message)
        return
      }

      const $myForm = $('#formprofile')
      if (!$myForm[0].checkValidity()) {
        this.showValidationAlert('กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง')
        return
      }

      this.editProfile()
    },
    logout() {
      Swal.fire({
        title: 'ออกจากระบบ',
        text: 'คุณต้องการออกจากระบบใช่หรือไม่?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'ตกลง',
        denyButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        }
      })
    },
    editProfile() {
      this.$store.state.isLoading = true
      const selectedCampus = this.campus_list.find((cp) => Number(cp.campus_id_pri) === Number(this.campus_id))
      const department = this.dep_list.find((dep) => Number(dep.department_id_pri) === Number(this.dep_id))
      const payload = {
        citizenId: this.citizen_id,
        fullname: this.fullname,
        email: this.email,
        tel: this.tel,
        school: this.school,
        facId: this.facId,
        depName: department ? department.department_name : this.depName,
        gender: this.gender,
        campus_id_pri: this.campus_id,
        department_id_pri: this.dep_id,
        major_id_pri: this.major,
        origin_province: this.origin_province_id,
        isConsent: 1,
        campus: selectedCampus ? selectedCampus.campus_name : '',
        participant_status: this.participant_status,
      }

      api.updateProfile(
        this.$store.state.URL,
        payload,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'success',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'ตกลง',
            }).then((result) => {
              this.$router.push('/activity').catch(() => { })
              this.$store.state.isLoading = false
            })
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
    getSchools() {
      this.$store.state.isLoading = true
      api.schoolData(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            this.school_lists = []
            result.data.forEach((v) => {
              this.school_lists.push(v['school_name'])
            })
            if (this.$refs.school) {
              this.$refs.school.inputValue = this.school
            }
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
    getReferenceData(serviceName, target) {
      this.$store.state.isLoading = true
      api[serviceName](
        this.$store.state.URL,
        this.header,
        (result) => {
          this.$store.state.isLoading = false
          if (result.status === 'SUCCESS') {
            this[target] = result.data
            return
          }

          Swal.fire({
            title: 'ตรวจสอบ',
            text: result.message,
            icon: 'warning',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'เข้าสู่ระบบใหม่',
            denyButtonText: 'ยกเลิก',
          }).then((_result) => {
            localStorage.clear()
            this.$router.push('/').catch(() => { })
          })
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
    getProvince() {
      this.getReferenceData('getProvince', 'province_list')
    },
    getCampus() {
      this.getReferenceData('getCampus', 'campus_list')
    },
    getFac() {
      this.getReferenceData('getFaculty', 'fac_list')
    },
    getDepart() {
      this.getReferenceData('getDepartment', 'dep_list')
    },
    getMajor() {
      this.getReferenceData('getMajor', 'major_list')
    },
  },
  mounted() {
    const auth = this.callbackToken(this.$store.state.user.citizenId)
    if (auth) {
      this.getProfile()
      this.getSchools()
      this.getProvince()
      this.getCampus()
      this.getFac()
      this.getDepart()
      this.getMajor()
    } else {
      localStorage.clear()
      this.$router.push('/').catch(() => { })
    }
  },
}
</script>

<style>
.form-page {
  width: min(1180px, calc(100% - 20px));
  margin: 0 auto;
  padding: 22px 0 110px;
  font-family: 'Mitr', sans-serif;
}

.form-card {
  border: 1px solid rgba(116, 87, 60, 0.16);
  border-radius: 8px;
  padding: 26px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 20px 54px rgba(76, 50, 31, 0.13);
}

.form-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(116, 87, 60, 0.12);
}

.heading-icon {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  color: #ffffff;
  background: linear-gradient(135deg, #5a3b25, #b9822e);
  box-shadow: 0 14px 28px rgba(185, 130, 46, 0.22);
}

.heading-icon img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.form-heading p {
  margin: 0 0 4px;
  color: #8a714f;
  font-size: 13px;
}

.form-heading h2 {
  margin: 0;
  color: #2f241b;
  font-size: 30px;
  font-weight: 600;
}

.profile-qr {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(180px, 220px);
  align-items: center;
  gap: clamp(20px, 4vw, 48px);
  margin-bottom: 24px;
  padding: clamp(18px, 3vw, 30px);
  overflow: hidden;
  border: 1px solid rgba(185, 130, 46, 0.24);
  border-radius: 8px;
  background: linear-gradient(135deg, #fffaf0, #ffffff);
}

.profile-qr__content {
  min-width: 0;
}

.profile-qr__eyebrow {
  margin: 0 0 6px;
  color: #9a6c28;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
}

.profile-qr__content h3 {
  margin: 0 0 8px;
  color: #2f241b;
  font-size: clamp(20px, 3vw, 28px);
  overflow-wrap: anywhere;
}

.profile-qr__content > p:not(.profile-qr__eyebrow) {
  margin: 0 0 14px;
  color: #735f4d;
  font-size: 14px;
}

.profile-qr__id {
  display: inline-block;
  max-width: 100%;
  padding: 6px 12px;
  border-radius: 999px;
  color: #5a3b25;
  background: rgba(185, 130, 46, 0.12);
  font-size: 14px;
  overflow-wrap: anywhere;
}

.profile-qr__download {
  min-height: 42px;
  padding: 0 16px;
  border: 0;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #ffffff;
  background: linear-gradient(135deg, #5a3b25, #b9822e);
  box-shadow: 0 9px 20px rgba(90, 59, 37, 0.18);
  font-family: 'Mitr', sans-serif;
  font-size: 14px;
  cursor: pointer;
}

.profile-qr__download:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.profile-qr__image-wrap {
  width: 100%;
  max-width: 220px;
  aspect-ratio: 1;
  justify-self: center;
  padding: 10px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(76, 50, 31, 0.12);
}

.profile-qr__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.profile-qr__placeholder {
  width: 100%;
  height: 100%;
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 8px;
  color: #8a714f;
  text-align: center;
  font-size: 12px;
}

.profile-qr__placeholder i {
  font-size: 48px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 18px;
}

.form-field {
  min-width: 0;
}

.field-wide {
  grid-column: 1 / -1;
}

.form-field label {
  display: block;
  margin-bottom: 8px;
  color: #3d3025;
  font-size: 14px;
  font-weight: 500;
}

.form-field .form-control,
.form-field .form-select {
  height: 44px;
  min-height: 44px;
  box-sizing: border-box;
  margin-bottom: 0 !important;
  border-color: #dccdb9;
  color: #2f241b;
  background-color: #ffffff;
  font-family: 'Mitr', sans-serif;
}

.form-field .form-control:focus,
.form-field .form-select:focus {
  border-color: #b9822e;
  box-shadow: 0 0 0 0.25rem rgba(185, 130, 46, 0.16);
}

.form-actions {
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.form-actions .btn {
  min-height: 48px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: 'Mitr', sans-serif;
  font-size: 18px;
}

.btn-primary-action {
  border: 0;
  color: #ffffff !important;
  background: linear-gradient(135deg, #5a3b25, #b9822e);
  box-shadow: 0 14px 26px rgba(185, 130, 46, 0.22);
}

.btn-primary-action i,
.btn-primary-action span {
  color: #ffffff !important;
}

.btn-secondary-action {
  border: 1px solid #dccdb9;
  color: #5a3b25;
  background: #fffaf0;
}

.btn-danger-action {
  border: 1px solid #dccdb9;
  color: #5a3b25;
  background: #fffaf0;
}

.btn-danger-action i,
.btn-danger-action span {
  color: #5a3b25 !important;
}

.regis-select2.select2-container {
  display: block;
  width: 100% !important;
  font-family: 'Mitr', sans-serif;
  font-size: 0.875rem;
  line-height: 1.4285714286;
}

.regis-select2 .select2-selection--single {
  height: 44px !important;
  min-height: 44px;
  box-sizing: border-box;
}

.regis-select2.select2-container--default .select2-selection--single {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.4375rem 2.25rem 0.4375rem 0.75rem;
  color: inherit;
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23a5a9b1' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #dccdb9;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.regis-select2.select2-container--default.select2-container--open .select2-selection--single,
.regis-select2.select2-container--default:focus-within .select2-selection--single {
  border-color: #b9822e;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(185, 130, 46, 0.16);
}

.regis-select2.is-invalid.select2-container--default .select2-selection--single,
.regis-select2.is-invalid.select2-container--default.select2-container--open .select2-selection--single,
.regis-select2.is-invalid.select2-container--default:focus-within .select2-selection--single {
  border-color: #d63939;
}

.regis-select2.is-invalid.select2-container--default.select2-container--open .select2-selection--single,
.regis-select2.is-invalid.select2-container--default:focus-within .select2-selection--single {
  box-shadow: 0 0 0 0.25rem rgba(214, 57, 57, 0.25);
}

.regis-select2.is-valid.select2-container--default .select2-selection--single,
.regis-select2.is-valid.select2-container--default.select2-container--open .select2-selection--single,
.regis-select2.is-valid.select2-container--default:focus-within .select2-selection--single {
  border-color: #2fb344;
}

.regis-select2.is-valid.select2-container--default.select2-container--open .select2-selection--single,
.regis-select2.is-valid.select2-container--default:focus-within .select2-selection--single {
  box-shadow: 0 0 0 0.25rem rgba(47, 179, 68, 0.25);
}

.regis-select2.select2-container--default .select2-selection--single .select2-selection__rendered {
  padding: 0;
  color: inherit;
  line-height: 1.4285714286;
}

.regis-select2.select2-container--default .select2-selection--single .select2-selection__arrow {
  display: none;
}

.regis-select2 .select2-container-dropdown {
  top: 100%;
}

.regis-select2 .select2-dropdown {
  border-color: #d9dbde;
  font-family: 'Mitr', sans-serif;
  font-size: 0.875rem;
}

@media (max-width: 767px) {
  .form-page {
    width: calc(100% - 12px);
    padding-top: 14px;
  }

  .form-card {
    padding: 18px;
  }

  .form-heading {
    margin-bottom: 18px;
  }

  .form-heading h2 {
    font-size: 25px;
  }

  .profile-qr {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .profile-qr__image-wrap {
    grid-row: 1;
    width: min(68vw, 220px);
  }

  .profile-qr__download {
    width: 100%;
  }

  .form-grid,
  .form-actions {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 375px) {
  .form-card {
    padding: 14px;
  }

  .profile-qr {
    padding: 14px;
  }

  .profile-qr__image-wrap {
    width: min(72vw, 200px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue